import { render, staticRenderFns } from "./CommentTeacher.vue?vue&type=template&id=48b6679c&scoped=true&"
import script from "./CommentTeacher.vue?vue&type=script&lang=js&"
export * from "./CommentTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6679c",
  null
  
)

export default component.exports